import { Chip } from "@mui/material";
import React from "react";

const QuoteStatus = ({ status }) => {
  const renderStatus = () => {
    switch (status) {
      case 1:
        return (
          <Chip
            label="Open"
            color="primaryXS"
            className="text-[10px] !h-[25px] shadow-xl font-medium tracking-wider uppercase"
          />
        );
      case 2:
        return (
          <Chip
            label="Complete"
            color="success"
            className="text-[10px] !h-[25px] shadow-xl font-medium tracking-wider uppercase"
          />
        );
      case 3:
        return (
          <Chip
            label="Archived"
            className="text-[10px] !h-[25px] shadow-xl font-medium tracking-wider uppercase !bg-red-100 !text-red-500"
          />
        );
      default:
        break;
    }
  };

  return renderStatus();
};

export default QuoteStatus;
